import { render, staticRenderFns } from "./IconTipsSign.vue?vue&type=template&id=c1248320&scoped=true&"
import script from "./IconTipsSign.vue?vue&type=script&lang=js&"
export * from "./IconTipsSign.vue?vue&type=script&lang=js&"
import style0 from "./IconTipsSign.vue?vue&type=style&index=0&id=c1248320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1248320",
  null
  
)

export default component.exports